import { render, staticRenderFns } from "./IconDownArrowFilled.vue?vue&type=template&id=a5149cf0&scoped=true"
import script from "./IconDownArrowFilled.vue?vue&type=script&lang=js"
export * from "./IconDownArrowFilled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5149cf0",
  null
  
)

export default component.exports